<template>
  <div>
    <Button type="primary" @click="modal = true" v-hasPermission="['approvalFlowConfiguration:node:add_node']">
      {{$t('approvalFlowConfigManagement.Node.addNode')}}
    </Button>
    <Modal v-model="modal" :title="$t('approvalFlowConfigManagement.Node.addNode')" :loading="loading"
           :mask-closable="false" :styles="{top:'65px'}"
           @on-ok="nodeSubmit('nodeForm')"
           @on-cancel="nodeReset('nodeForm')"
           :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
      <Form ref="nodeForm" :model="nodeForm" :label-width="100" :rules="ruleValidate">
        <!-- 节点名称 -->
        <FormItem :label="$t('approvalFlowConfigManagement.Node.nodeName')" prop="nodeName">
          <Input v-model="nodeForm.nodeName" style="width:300px;"></Input>
        </FormItem>

        <!-- 类型 -->
        <FormItem :label="$t('approvalFlowConfigManagement.Node.type')" prop="type">
          <Select v-model="nodeForm.type" style="width:300px;" @on-change="changeType(nodeForm.type)" :placeholder="$t('configuration_management.common.pleaseSelect')">
            <Option :value="item.id" v-for="item in typeList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <div v-if="isCompany">
          <!-- 公司 -->
          <FormItem :label="$t('approvalFlowConfigManagement.approvalFlow.companyName')" prop="companyId">
            <Select v-model="nodeForm.companyId" style="width:300px;" @on-change="changeCompany(nodeForm.companyId)" :placeholder="$t('configuration_management.common.pleaseSelect')">
              <Option :value="item.id" v-for="item in companyIdList" v-bind:key="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
        </div>
        <div v-if="isUser">
          <!-- 用户 -->
          <FormItem :label="$t('approvalFlowConfigManagement.Node.user')" prop="owner">
            <Select v-model="nodeForm.owner" style="width:300px;" :placeholder="$t('configuration_management.common.pleaseSelect')">
              <Option :value="item.id" v-for="item in ownerList" v-bind:key="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
        </div>
        <div v-if="isRole">
          <!-- 角色 -->
          <FormItem :label="$t('approvalFlowConfigManagement.Node.role')" prop="role">
            <Select v-model="nodeForm.role" style="width:300px;" :placeholder="$t('configuration_management.common.pleaseSelect')">
              <Option :value="item.id" v-for="item in roleList" v-bind:key="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
  import TableNode from '../node/TableNode.vue'

  var tableNode = TableNode;
  export default {
    data() {
      return {
        isUser: false,
        isRole: false,
        isCompany: false,
        nodeForm: {
          nodeName: '',
          type: '',
          owner: '',
          role: '',
          companyId: ''
        },
        typeList: [{
          id: 0,
          name: this.$t('approvalFlowConfigManagement.Node.user')
        }, {
          id: 1,
          name: this.$t('approvalFlowConfigManagement.Node.role')
        }],
        companyIdList: [],
        ownerList: [],
        roleList: [],
        loading: true,
        modal: false,
        ruleValidate: {
          nodeName: [
            {required: true, message: this.$t('approvalFlowConfigManagement.Node.nodeNameNotEmpty'), trigger: 'blur'},
            {type: 'string', message: this.$t('approvalFlowConfigManagement.Node.nodeNameValidateMsg'), pattern: '^.{4,20}$', trigger: 'blur'}
          ],
          type: [
            {required: true, message: this.$t('approvalFlowConfigManagement.Node.pleaseSelectNodeType'), trigger: 'change', type: 'number'}
          ],
          owner: [
            {required: true, message: this.$t('approvalFlowConfigManagement.Node.pleaseSelectUser'), trigger: 'change', type: 'number'}
          ],
          role: [
            {required: true, message: this.$t('approvalFlowConfigManagement.Node.pleaseSelectRole'), trigger: 'change', type: 'number'}
          ],
          companyId: [
            {required: true, message: this.$t('approvalFlowConfigManagement.Node.pleaseSelectCompany'), trigger: 'change', type: 'number'}
          ]
        }
      }
    },
    mounted() {
      this.getCompanyDropDownBox();
    },
    methods: {
      // 切换类型
      changeType: function () {
        if (this.nodeForm.type == 0) {
          this.isUser = true;
          this.isRole = false;
          this.isCompany = true;
        } else if (this.nodeForm.type == 1) {
          this.isUser = false;
          this.isRole = true;
          this.isCompany = true;
        }
        this.changeCompany();
      },
      //公司下拉框
      getCompanyDropDownBox: function () {
        this.nodeForm.companyId = '';
        this.$api.company.getCompanyDropDownBox("userName", getCookie(global.cookieName))
          .then(res => {
            this.companyIdList = res.data;
          })
      },
      // 切换公司
      changeCompany: function () {
        if (!this.nodeForm.companyId || this.nodeForm.companyId == '' || this.nodeForm.companyId == null) {
          return;
        } else {
          if (this.isRole) {
            this.nodeForm.role = '';
            this.$api.user.queryRole("companyId", this.nodeForm.companyId)
              .then(res => {
                this.roleList = res.data;
              })
          }
          if (this.isUser) {
            this.nodeForm.owner = '';
            this.$api.user.queryUserByCompanyId("companyId", this.nodeForm.companyId)
              .then(res => {
                this.ownerList = res.data;
              })
          }
          if (this.isCompany) {
            this.nodeForm.role = '';
            this.nodeForm.owner = '';
          }
        }

      },
      nodeSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            var updateDate = {
              "name": this.nodeForm.nodeName,
              "companyId": this.nodeForm.companyId,
              "type": this.nodeForm.type
            };
            if (this.nodeForm.type == 0) {
              updateDate.owner = this.nodeForm.owner;
            } else if (this.nodeForm.type == 1) {
              updateDate.role = this.nodeForm.role;
            }
            // 添加
            this.$api.processNode.createProcessNode(updateDate)
              .then(res => {
                setTimeout(() => {
                  tableNode.methods.showAll();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success('添加成功');
                  this.modal = false;
                  this.isUser = false;
                  this.isRole = false;
                }, 1000);
              })
          } else {
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error('添加失败');
          }
        });
      },
      nodeReset: function (name) {
        this.modal = false;
        this.isUser = false;
        this.isRole = false;
        this.$refs[name].resetFields();
        this.companyIdList = [];
        this.ownerList = [];
        this.roleList = [];
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/approval_flow_configuration/node/AddNode.vue